import React from 'react';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import './Header.css';

class Header extends React.Component {

  constructor(props) {
    super(props);

    this.route = this.route.bind(this);
    this.routeAnchor = this.routeAnchor.bind(this);
  }

  routeAnchor(event) { 
    event.preventDefault();
    this.route(null, event);
  }

  route(key, event) {
    event.preventDefault();
    // if(event.target.href.indexOf("/splinter-log.com") > 0) {
    //   console.log("pushUrl(" + extractPath(event.target.href) + ")");
    //   this.context.router.push(extractPath(event.target.href));
    // } else {
      window.location.assign(event.target.href);
    // }
  }

  render() {
    return (
      <div>
        <Navbar collapseOnSelect fixedTop >
          <Navbar.Header>
            <Navbar.Brand>
                <a href='/' className='logoText' onClick={this.routeAnchor}>Splinter</a>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav onSelect={this.route}>
              <NavItem eventKey={1} href="/#/releases">Releases</NavItem>
              <NavItem eventKey={2} href="/#/buy" >Buy</NavItem>
              <NavDropdown eventKey={3} title="Docs" id="basic-nav-dropdown">
                <MenuItem eventKey={3.1} href="/#/docs/custom-log-format">Custom Log Formats</MenuItem>
                <MenuItem eventKey={3.2} href="/#/docs/producing-graphs">Producing Graphs</MenuItem>
                
              </NavDropdown>
              <NavItem eventKey={4} href="/#/support">Support</NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {this.props.children}
        <div className="center">
          <center>
            <a href="https://twitter.com/SplinterLog" className="twitter-follow-button" data-show-count="false">Follow @SplinterLog</a><br/><br/>
            <p className="subtext">Copyright © 2017 Dimitar Zlatkov</p>

            </center>
        </div>
        <br/><br/>
      </div>
      ); 
  }
}

Header.contextTypes = {
    router: React.PropTypes.object
};

export default Header;
    


// WEBPACK FOOTER //
// ./src/Header.js